import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import WsPermissionModalComp from './ws-permission';

let root: Root;

const WsPermissionModal = (props) => {
  const rootEl = document.getElementById('app-portal-container');
  if (rootEl) {
    root?.unmount();
    root = createRoot(rootEl);
    root.render(<WsPermissionModalComp {...props} />);
  }
}

window.WsPermissionModal = WsPermissionModal;
export default WsPermissionModal;
